export default {
  presenter: 'veverka',
  title: 'Zaciname s Dockerem',
  subtitle: 'začátečníci',
  text: `
Kratky uvod do Dockeru. Jak jednoduse zabalit a distribuovat aplikaci aby byla snadno spustitelna
na temer jakemkoliv prostredi. Prednaska bude obsahovat zakladni seznameni s Dockerem a par 
dobrych rad do zacatku.
  `,
}



// WEBPACK FOOTER //
// ./src/content/installfest/data/presentations/veverka-docker.js